import { Text } from '@amo/core/components/forms';
import { Field } from 'redux-form';
import {getTranslation} from "@amo/core/utils/index.js";
import { validatePersonName } from '@amo/core/utils/validateField';

const TiersPayeurBirthName = () => {
    return (
        <div className={'row justify-content-center'}>
            <div className={'col-lg-8 col-md-6 col-sm-6 col-12 my-2'}>
                <Field
                    name={`DemandeContrat[TiersPayeur][BirthName]`}
                    label={getTranslation('birthName')}
                    component={Text}
                    validate={[validatePersonName]}
                    normalize={(v) => v.toUpperCase()}
                    type={'text'}
                    maxLength={20}
                />
            </div>
        </div>
    );
};

export default TiersPayeurBirthName;
